<template>
  <LoaderWrapper ref="pageLoader" class="h-100">
    <div class="row mt-0">
      <div class="col-sm-12">
        <div class="row">

          <div class="col-sm-12">
            <div class="card card-body">
              <div class="row">


                <div class="form-group col-sm-12">
                  <button v-if="isTrader" type="button" v-on:click="showEditModal()" class="btn btn-outline-dark btn-sm rounded-pill float-end text-capitalize"><i class="fa fa-plus"></i> {{ helper.trans('button.create') }}</button>
                  <b-modal v-if="isTrader" dialog-class="modal-lg"
                           :title="createModalTitle"
                           :modelValue="createModal"
                           body-class="pt-0"
                           @update:modelValue="createModal = $event"
                  >
                    <template #default>
                      <PayoutMethodForm ref="createForm"></PayoutMethodForm>
                    </template>
                    <template #footer>
                      <button type="button" v-on:click="createModal = false" class="btn btn-outline-secondary btn-sm text-capitalize-first">{{ helper.trans('button.cancel') }}</button>
                      <LoaderWrapper ref="loaderCreateFrom" :zoom="0.5">
                        <button type="button" @click="save()" class="btn btn-outline-primary btn-sm text-capitalize-first">{{ helper.trans('button.save') }}</button>
                      </LoaderWrapper>
                    </template>
                  </b-modal>

                </div>
              </div>

              <div class="overflow-auto">
                <table class="table table-striped border-light align-middle text-left text-nowrap position-relative">
                  <thead>
                  <tr>
                    <th v-if="isAdmin || isOperator" class="text-capitalize-first">{{ helper.trans('labels.trader') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.payment_method') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.currency') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.count_limits') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.sum_limits') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.status') }}</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in payoutMethods.items" :key="item.id" class="">
                    <td v-if="isAdmin || isOperator">
                      <UserNameLabel v-if="item.trader" :user="item.trader"/>
                    </td>
                    <td>
                      <div class="d-flex flex-row align-items-center gap-2 mt-1 mb-1">
                        <PayMethodIcon :method="item.method"></PayMethodIcon>
                        <div class="d-flex flex-column">
                          <span>{{ helper.trans('pay_methods.' + item.method) }}
                          </span>
                        </div>

                      </div>
                    </td>
                    <td>
                      {{ item.currency }}
                    </td>
                    <td>
                      <div class="d-flex flex-column">
                        <span>{{ item.dayTradesCount }}/{{ item.dayTradesCountLimit }}</span>
                        <span>{{ item.monthTradesCount }}/{{ item.monthTradesCountLimit }}</span>
                      </div>
                    </td>

                    <td>
                      <div class="d-flex flex-column">
                        <span>{{ numberFormatter.formatNumber(item.dayTradesSum) }}/{{ numberFormatter.formatNumber(item.dayTradesSumLimit) }}</span>
                        <span>{{ numberFormatter.formatNumber(item.monthTradesSum) }}/{{ numberFormatter.formatNumber(item.monthTradesSumLimit) }}</span>

                      </div>
                    </td>

                    <td>
                      <span v-if="item.isActive" class="text-success text-capitalize-first">
                        {{ helper.trans('requisites.active') }}
                      </span>
                      <span v-else class="text-danger text-capitalize-first">
                        {{ helper.trans('requisites.inactive') }}
                      </span>
                    </td>
                    <td class="text-end">
                      <button v-if="isTrader" type="button" @click="showEditModal(item)" class="btn btn-sm btn-outline-dark text-nowrap me-2 text-capitalize"><i class="fa fa-pencil"></i> {{helper.trans('button.edit')}}</button>
                      <button v-if="isTrader" type="button" @click="deletePayoutMethod = item" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize"><i class="fa fa-trash"></i> {{helper.trans('button.delete')}}</button>
                      <div v-if="isAdmin || isOperator">
                        <div class="form-check form-switch d-flex align-items-center">
                          <input v-model="{isActive: item.isActive}.isActive" @change="toggleActivity($event, item)" id="isActive" class="form-check-input" style="cursor: pointer" type="checkbox" role="switch">
                        </div>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <b-pagination
                  v-if="payoutMethods.totalCount > payoutMethods.items.length"
                  v-model="page"
                  :total-rows="payoutMethods.totalCount"
                  :per-page="payoutMethods.limit"
                  :limit="20"
                  @update:modelValue="load()"
                  :prev-text="helper.trans('button.back')"
                  :next-text="helper.trans('button.next')"
                  align="start"
                  first-number
                  hide-goto-end-buttons
                  hide-ellipsis
                ></b-pagination>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
    <div>
      <b-modal :title="helper.trans('labels.delete_confirm')" :modelValue="deletePayoutMethod !== null" body-class="d-none" footer-class="border-top-0 d-flex justify-content-between" @update:modelValue="$event === false && (deletePayoutMethod = null)">
        <template #footer>
          <button type="button" @click="deletePayoutMethod = null" class="btn btn-outline-dark btn-sm text-capitalize">{{ helper.trans('button.cancel') }}</button>
          <LoaderWrapper ref="loaderDelete" :zoom="0.5">
            <button type="button" @click="confirmDelete()" class="btn btn-outline-danger btn-sm text-capitalize">{{ helper.trans('button.delete') }}</button>
          </LoaderWrapper>

        </template>
      </b-modal>
    </div>
  </LoaderWrapper>
</template>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import CopyButton from "@/components/CopyButton.vue";
import {computed, defineComponent, onMounted, reactive, ref, toRefs} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import APIClient from "@/service/APIClient";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import {helper} from "@/service/CommonHelper";
import {BModal, BPagination} from "bootstrap-vue-3";
import PayoutMethodForm from "@/components/Form/PayoutMethodForm.vue";
import PayoutMethodFormDTO from "@/models/form/PayoutMethodFormDTO";
import {useNotification} from "@kyvg/vue3-notification";
import {useStore} from "vuex";
import PaginationDTO from "@/models/PaginationDTO";
import UserNameLabel from "@/components/UserNameLabel.vue";
import TraderPayoutMethodDTO from "@/models/TraderPayoutMethodDTO";
import PayoutMethodUpdateRequestDTO from "@/models/request/PayoutMethodUpdateRequestDTO";
import PayMethodIcon from "@/components/PayMethodIcon.vue";

const api = new APIClient();
const notification = useNotification()

const defaultCreateForm = {
  id: null,
  isActive: false,
  method: null,
  currency: null,
  dayTradesCountLimit: null,
  monthTradesCountLimit: null,
  dayTradesSumLimit: null,
  monthTradesSumLimit: null,
} as PayoutMethodFormDTO

export default defineComponent({
  name: 'PayOutRequisites',
  components: {
    PayMethodIcon,
    LoaderWrapper,
    CopyButton,
    BPagination,
    BModal,
    PayoutMethodForm,
    UserNameLabel
  },
  setup() {
    const store = useStore();

    const pageLoader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const loaderCreateFrom = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const loaderDelete = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const createForm = ref<InstanceType<typeof PayoutMethodForm> | null>(null)

    const state = reactive({
      deletePayoutMethod: null as TraderPayoutMethodDTO|null,
      createModal: false,
      devicesModal: false,
      groupsModal: false,
      createModalTitle: '',
      page: 1,
      payoutMethods: {
          limit: 20,
          offset: 0,
          totalCount: 0,
          items: []
      } as PaginatedResponseDTO<TraderPayoutMethodDTO>
    });

    const load = async () => {
      state.payoutMethods.offset = state.payoutMethods.limit * (state.page - 1)
      pageLoader.value?.show()
      state.payoutMethods = await api.payoutMethods(state.payoutMethods, {createdAt: 'desc'})
      const traderIds = state.payoutMethods.items.map(req => req.traderId);

      let traders = [];
      if (store.getters.isAdmin || store.getters.isOperator) {
        for (const trader of (await api.traders({offset:0, limit: traderIds.length} as PaginationDTO, {ids: traderIds})).items) {
          traders[trader.id] = trader
        }
      }

      for (const item of state.payoutMethods.items) {
        item.trader = traders[item.traderId] ?? null;
      }

      pageLoader.value?.hide()
    }

    const toggleActivity = async ($event: any, item: TraderPayoutMethodDTO) => {
      pageLoader.value?.show();
      try {
        const req = await api.togglePayoutMethodActivity(item.id, $event.target.checked ? 'enable' : 'disable')
        item.isActive = req.isActive
      } finally {
        pageLoader.value?.hide()
      }
    }

    const showEditModal = async (dto: TraderPayoutMethodDTO|null = null) => {
      if (!dto) {
        createForm.value?.setForm({...defaultCreateForm} as PayoutMethodFormDTO)
        state.createModalTitle = helper.trans('labels.create_requisites')
      } else {
        state.createModalTitle = helper.trans('labels.edit_requisites', {req: dto.method})
        createForm.value?.setForm({
          ...defaultCreateForm,
          ...dto,
          dayTradesSum: dto.dayTradesSum.amount,
          dayTradesSumLimit: Number.parseInt(dto.dayTradesSumLimit.amount).toString(),
          monthTradesSum: dto.monthTradesSum.amount,
          monthTradesSumLimit: Number.parseInt(dto.monthTradesSumLimit.amount).toString(),
        } as PayoutMethodFormDTO)
      }
      state.createModal = true;
    }

    const confirmDelete = async () => {
      if (!state.deletePayoutMethod) {
        return;
      }
      loaderDelete.value?.show()
      await api.deletePayoutMethod(state.deletePayoutMethod.id)
      loaderDelete.value?.hide()
      state.deletePayoutMethod = null
      load();
    }

    const save = () => {
      loaderCreateFrom.value?.show()

      const form = createForm.value!.getForm();

      const data = {
        ...form,
        dayTradesCountLimit: form.dayTradesCountLimit ? Number.parseInt(form.dayTradesCountLimit!.toString()!.replace(/\s/g, '')) : 0,
        monthTradesCountLimit: form.monthTradesCountLimit ? Number.parseInt(form.monthTradesCountLimit!.toString()!.replace(/\s/g, '')) : 0,
        monthTradesSumLimit: form.monthTradesSumLimit ? Number.parseInt(form.monthTradesSumLimit!.replace(/\s/g, '')) : 0,
        dayTradesSumLimit: form.dayTradesSumLimit ? Number.parseInt(form.dayTradesSumLimit!.replace(/\s/g, '')) : 0,
      } as PayoutMethodUpdateRequestDTO;

      let promise;
      if (form.id) {
        promise = api.payoutMethodsUpdate(form.id, data)
          .then((resp) => {
            notification.notify({title: helper.trans('requisites.notice.updated')});
          })
      } else {
        promise = api.payoutMethodsCreate(data)
          .then((resp) => {
            notification.notify({title: helper.trans('requisites.notice.created')});
          })
      }

      promise
        .then((resp) => {
          state.createModal = false;
          load();
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          loaderCreateFrom.value?.hide();
        })

    }

    onMounted(() => {
      load();
    });

    return {
      ...toRefs(state),
      pageLoader,
      dateHelper,
      helper,
      numberFormatter,
      createForm,
      load,
      showEditModal,
      toggleActivity,
      loaderCreateFrom,
      loaderDelete,
      save,
      confirmDelete,
      store,
      isAdmin: computed(() => store.getters.isAdmin),
      isOperator: computed(() => store.getters.isOperator),
      isTrader: computed(() => store.getters.isTrader),
    }
  }
})
</script>
